import { action, actionOn, thunk } from "easy-peasy";
import axios from '../services/axios';

const categoriesInitialState = {
    allCategories: [],
    isFetchingAllCategories: false,
    isUpdateNecessary: true,
    initialFetchDone: false,
}

const categories = {
    ...categoriesInitialState,

    onGlobalResetCalled: actionOn(
        (actions, storeActions) => [
            storeActions.resetStore.performReset,
        ],
        (state, target) => {
            const [performReset] = target.resolvedTargets;

            if (target.type === performReset) {
                ({
                    allCategories: state.allCategories,
                    isFetchingAllCategories: state.isFetchingAllCategories,
                    isUpdateNecessary: state.isUpdateNecessary,
                    initialFetchDone: state.initialFetchDone
                } = categoriesInitialState);
            }
        }
    ),

    setAllCategories: action((state, payload) => {
        state.allCategories = payload;
    }),

    setIsFetchingAllCategories: action((state, payload) => {
        state.isFetchingAllCategories = payload;
    }),

    setIsUpdateNecessary: action((state, payload) => {
        state.isUpdateNecessary = payload;
    }),

    setInitialFetchDone: action((state, payload) => {
        state.initialFetchDone = payload;
    }),

    fetchCategories: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { isFetchingAllCategories, isUpdateNecessary } = helpers.getState();

        const getCategoriesUrl = ACTIONS?.categories?.readAll?.url;
        if (getCategoriesUrl && !isFetchingAllCategories && isUpdateNecessary) {
            actions.setIsFetchingAllCategories(true);
            return axios.get(getCategoriesUrl)
                .then((result) => {
                    actions.setAllCategories(result);
                    actions.setIsFetchingAllCategories(false);
                    actions.setIsUpdateNecessary(false);
                    return result;
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        } else {
            return Promise.resolve();
        }
    }),

    addCategory: action((state, payload) => {
        for (const element of payload) {
            const existingCategories = state.allCategories.find(category => category?.uniqueId === element.uniqueId);
            if (existingCategories === undefined) {
                state.allCategories.push(element);
            }
        }
    }),

    createCategory: thunk((actions, payload, helpers) => {
        const data = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const createCategoryUrl = ACTIONS?.categories?.create?.url;

        return axios.post(createCategoryUrl, data)
            .then((result) => {
                actions.addCategory(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    updateCategoryProps: thunk((actions, payload, helpers) => {
        const allCategories = helpers.getState().allCategories;

        const newAllCategories = allCategories
            .map(category => {
                const newCategory = payload?.find(cat => category.uniqueId === cat.uniqueId);
                return { ...category, ...newCategory }
            });

        actions.setAllCategories(newAllCategories);
    }),

    updateCategory: thunk((actions, payload, helpers) => {
        const { data, uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const updateCategoryUrl = ACTIONS?.categories?.update?.url?.replace('uniqueId', uniqueId);

        return axios.post(updateCategoryUrl, data)
            .then((result) => {
                actions.updateCategoryProps(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    removeCategory: action((state, payload) => {
        state.allCategories = state.allCategories.filter(category => category?.uniqueId !== payload);
    }),

    deleteCategory: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const deleteCategoryUrl = ACTIONS?.categories?.delete?.url?.replace('uniqueId', uniqueId);
        const data = { csrfToken: ACTIONS?.categories?.delete?.csrfToken };

        return axios.post(deleteCategoryUrl, data)
            .then((result) => {
                actions.removeCategory(uniqueId);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

}

export default categories;